import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Render React app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Load Google Translate script outside React
const script = document.createElement('script');
script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
script.async = true;
document.body.appendChild(script);

// Define global callback
window.googleTranslateElementInit = function () {
  new window.google.translate.TranslateElement(
    {
      pageLanguage: 'en',
      includedLanguages: 'af,ach,ak,am,ar,az,be,bem,bg,bh,bn,br,bs,ca,chr,ckb,co,crs,cs,cy,da,de,ee,el,en,eo,es,es-419,et,eu,fa,fi, fo,fr,fy,ga,gaa,gd,gl,gn,gu,ha,haw,hi,hr,ht,hu,hy,ia, id,ig,is,it,iw,ja,jw,ka,kg,kk,km,kn,ko,kri,ku,ky,la, lg,ln,lo,loz,lt,lua,lv,mfe,mg,mi,mk,ml,mn,mo,mr,ms,mt, ne,nl,nn,no,nso,ny,nyn,oc,om,or,pa,pcm,pl,ps,pt-BR, pt-PT,qu,rm,rn,ro,ru,rw,sd,sh,si,sk,sl,sn,so,sq,sr, sr-ME,st,su,sv,sw,ta,te,tg,th,ti,tk,tl,tn,to,tr,tt, tum,tw,ug,uk,ur,uz,vi,wo,xh,yi,yo,zh-CN,zh-TW,zu',
      layout: window.google.translate.TranslateElement.InlineLayout.VERTICAL,
    },
    'google_translate_element'
  );
};

// Show/hide logic for translate
const icon = document.getElementById('custom_translate_icon');
const container = document.getElementById('google_translate_container');

let isTranslateOpen = false;

icon.addEventListener('click', (e) => {
  e.stopPropagation(); // Prevent bubbling to document
  container.style.display = 'block';
  icon.style.display = 'none';
  isTranslateOpen = true;
});

// Click outside = close dropdown
document.addEventListener('click', (e) => {
  if (isTranslateOpen) {
    container.style.display = 'none';
    icon.style.display = 'block';
    isTranslateOpen = false;
  }
});

// Prevent hiding if user clicks inside translate box
container.addEventListener('click', (e) => {
  e.stopPropagation();
});



reportWebVitals();
